<template>
  <v-card>
    <v-card-text>
      <h2><v-icon>pie_chart</v-icon>&#160;Instructions / Completions</h2>
      <div style="overflow: auto; overflow-y: hidden">
        <table class="basic">
          <tr>
            <th>wk</th>
            <th
              v-for="(before, index) in statsPanel.before"
              :key="`weekbefore${index}`"
            >
              {{ before.current.week }}
            </th>
            <th colspan="2">Avg</th>
            <th colspan="2">{{ statsPanel.during.current.week }}</th>
            <th
              v-for="(after, index) in statsPanel.after"
              :key="`weekafter${index}`"
            >
              {{ after.current.week }}
            </th>
          </tr>
          <tr>
            <th>I</th>
            <td
              v-for="(before, index) in statsPanel.before"
              :key="`instructionsbefore${index}`"
              :class="before.instructions.style.files"
            >
              {{ before.instructions.current.files }}
            </td>
            <td style="font-size: 0.8em">
              {{ statsPanel.instructions.difference.files }}
            </td>
            <td :class="statsPanel.instructions.style.files">
              {{ statsPanel.instructions.current.files }}
            </td>
            <td style="font-size: 0.8em">
              {{ statsPanel.during.instructions.difference.files }}
            </td>
            <td :class="statsPanel.during.instructions.style.files">
              {{ statsPanel.during.instructions.current.files }}
            </td>
            <td
              v-for="(after, index) in statsPanel.after"
              :key="`instructionsafter${index}`"
              :class="after.instructions.style.files"
            >
              {{ after.instructions.current.files }}
            </td>
          </tr>
          <tr>
            <th>C</th>
            <td
              v-for="(before, index) in statsPanel.before"
              :key="`completionsbefore${index}`"
              :class="before.completions.style.files"
            >
              {{ before.completions.current.files }}
            </td>
            <td style="font-size: 0.8em">
              {{ statsPanel.completions.difference.files }}
            </td>
            <td :class="statsPanel.completions.style.files">
              {{ statsPanel.completions.current.files }}
            </td>
            <td style="font-size: 0.8em">
              {{ statsPanel.during.completions.difference.files }}
            </td>
            <td :class="statsPanel.during.completions.style.files">
              {{ statsPanel.during.completions.current.files }}
            </td>
            <td
              v-for="(after, index) in statsPanel.after"
              :key="`completionsafter${index}`"
              :class="after.completions.style.files"
            >
              {{ after.completions.current.files }}
            </td>
          </tr>
        </table>
      </div>
      <br />
      <div style="overflow: auto; overflow-y: hidden">
        <table class="basic">
          <tr>
            <th>wk</th>
            <th
              v-for="(before, index) in statsPanel.before"
              :key="`weekbefore${index}`"
            >
              {{ before.current.week }}
            </th>
            <th colspan="2">Avg</th>
            <th colspan="2">{{ statsPanel.during.current.week }}</th>
            <th
              v-for="(after, index) in statsPanel.after"
              :key="`weekafter${index}`"
            >
              {{ after.current.week }}
            </th>
          </tr>
          <tr>
            <th>I</th>
            <td
              v-for="(before, index) in statsPanel.before"
              :key="`instructionsbefore${index}`"
              :class="before.instructions.style.files"
            >
              {{ before.instructions.current.files }}
            </td>
            <td style="font-size: 0.8em">
              {{ statsPanel.instructions.difference.files }}
            </td>
            <td :class="statsPanel.instructions.style.files">
              {{ statsPanel.instructions.current.files }}
            </td>
            <td style="font-size: 0.8em">
              {{ statsPanel.during.instructions.difference.files }}
            </td>
            <td :class="statsPanel.during.instructions.style.files">
              {{ statsPanel.during.instructions.current.files }}
            </td>
            <td
              v-for="(after, index) in statsPanel.after"
              :key="`instructionsafter${index}`"
              :class="after.instructions.style.files"
            >
              {{ after.instructions.current.files }}
            </td>
          </tr>
          <tr>
            <th>Q</th>
            <td
              v-for="(before, index) in statsPanel.before"
              :key="`instructionsbefore${index}`"
              :class="before.instructions.style.quotes"
            >
              {{ before.instructions.current.quotes }}
            </td>
            <td style="font-size: 0.8em">
              {{ statsPanel.instructions.difference.quotes }}
            </td>
            <td :class="statsPanel.instructions.style.quotes">
              {{ statsPanel.instructions.current.quotes }}
            </td>
            <td style="font-size: 0.8em">
              {{ statsPanel.during.instructions.difference.quotes }}
            </td>
            <td :class="statsPanel.during.instructions.style.quotes">
              {{ statsPanel.during.instructions.current.quotes }}
            </td>
            <td
              v-for="(after, index) in statsPanel.after"
              :key="`instructionsafter${index}`"
              :class="after.instructions.style.quotes"
            >
              {{ after.instructions.current.quotes }}
            </td>
          </tr>
        </table>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: "StatsPanel",
  props: ["statsPanel"]
};
</script>

<style lang="stylus" scoped>
td.statsGood {
  text-align: right;
  color: green;
}

td.statsVeryGood {
  text-align: right;
  color: green;
  font-weight: bold;
}

td.statsBad {
  text-align: right;
  color: red;
}

td.statsVeryBad {
  text-align: right;
  color: red;
  font-weight: bold;
}

td.statsNormal {
  text-align: right;
  color: black;
}
</style>